module.exports = __webpack_public_path__ + "rodovia-br-101.9c13072e89cc9bb79eba026012db815c.jpg";